<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 2a22 22 0 1 0 0 44 22 22 0 0 0 0-44m3 33a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V23c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2zm-3-17a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7"/></svg>
</template>
